import { render, staticRenderFns } from "./FtaTitle.vue?vue&type=template&id=33b320de&scoped=true"
import script from "./FtaTitle.vue?vue&type=script&lang=js"
export * from "./FtaTitle.vue?vue&type=script&lang=js"
import style0 from "./FtaTitle.vue?vue&type=style&index=0&id=33b320de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b320de",
  null
  
)

export default component.exports